import * as am4core from "@amcharts/amcharts4/core"
import * as am4charts from "@amcharts/amcharts4/charts"
import {removeDimensionSortPrefix} from "@/cube/removeDimensionSortPrefix"

export function dropSortPrefixAdapter(
  text: string | undefined,
  target: am4core.Slice
): string | undefined {
  const dataItem = <am4charts.PieSeriesDataItem>target.dataItem
  const category = removeDimensionSortPrefix(dataItem.category)
  return text?.replace("{category}", category)
}
